// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: tools/eigen_lcm/lcmtypes/eigen_lcm.lcm

import { double } from "@skydio/lcm/src/types";

import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmMsg from "@skydio/lcm/src/lcm";
import ReflectionMeta from "@skydio/lcm/src/reflection";

export class Vector3d extends LcmMsg {

  private static _hash = Long.fromString("9091412288927245297", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (Vector3d._packed_fingerprint === undefined) {
      Vector3d._packed_fingerprint = Vector3d._get_hash_recursive([]);
    }
    return Vector3d._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(Vector3d) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = Vector3d._hash;
    return tmp_hash.shl(1).add(tmp_hash.shru(63));
  }

  /** @internal */
  public static override _reflection_meta: ReflectionMeta = {
    data: { kind: "array", dims: [{ kind: "fixed", size: 3 }], nDim: 1, inner: { kind: "primitive", type: Number, typeStr: "double" } },
  };

  public data: double[];

  public override decode(byte_array: Uint8Array): Vector3d {
    const decoder = new Decoder(new DataView(
      byte_array.buffer, byte_array.byteOffset, byte_array.byteLength
    ));
    const hash = decoder.decode_hash();
    if (!hash.equals(Vector3d._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, Vector3d._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  public override decode_one(decoder: Decoder): Vector3d {
    this.data = new Array(3);
    for (let i0 = 0; i0 < 3; i0++) {
      this.data[i0]! = decoder.decode_double();
    }
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    let total_size = 0;
    total_size += 8 * 3;
    return total_size;
  }

  public override encode(): ArrayBufferLike {
    const encoder = new Encoder(8 + this._get_encoded_size()); // hash + rest
    encoder.encode_hash(Vector3d._get_packed_fingerprint());
    this.encode_one(encoder);

    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    for (let i0 = 0; i0 < 3; i0++) {
      encoder.encode_double(this.data[i0]!);
    }
  }

  constructor(init?: {data?: double[] }) {
    super();
    this.data = new Array(3).fill(0.0);

    // optionally override default values
    if (!init) {
      return;
    }
    this.data = init.data || this.data;
  }
}